import { formatScore } from 'FormatScore';
import { type StreamForStreamDashboard } from 'Lessons';
import { isStreamComplete } from './streamSelectors';

/**
 * Mirrors the `examScore` property on the stream dashboard scope.
 *
 * NOTE: keep this rounding in step with AssessmentScoreArc, or an exam stream with a single lesson can
 * show an exam score that differs from that lesson's score.
 */
export const getExamScore = (stream: StreamForStreamDashboard): string | null => {
    const officialTestScore = stream.lessonStreamsProgress?.officialTestScore;

    if (stream.exam && isStreamComplete(stream) && officialTestScore) {
        return `${formatScore(officialTestScore)}%`;
    }

    return null;
};
